import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { SelectParticipantRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { SelectParticipantResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const selectParticipants = (request: SelectParticipantRequest, options?: CashRequestOptions) =>
  post<SelectParticipantRequest, SelectParticipantResponse>('/2.0/cash/select-participants', request, {
    ...options,
    rejectOnError: true,
  })
